var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<leaflet id=\"mymap\" lf-center=\"$ctrl.center\" tiles=\"$ctrl.tiles\" geojson=\"$ctrl.geojson\" width=\"100%\" height=\"480px\"></leaflet><div class=\"worldmap state f32\"><div ng-show=\"$ctrl.selectedState\">{{$ctrl.selectedState.properties.name}}<br/><div ng-if=\"$ctrl.selectedState.properties.sales\">Sales : {{$ctrl.selectedState.properties.sales|currency}}</div></div></div>";
var id1="county-view.htm";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;